module.exports = ".kan-dog-container {\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 0 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #ffffff;\n  z-index: 3; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/components/dog/dog/component.scss
// module id = ./src/modules/admin/components/dog/dog/component.scss
// module chunks = main